import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Footer = () => (
  <footer className="bg-taxi-darker border-t border-border">
    <div className="container-custom py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-4">

            <span className="text-xl font-bold text-foreground">
              pondicherry.taxi
            </span>
          </div>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Your trusted taxi service in Pondicherry. Affordable, safe, and reliable cab booking for local and outstation travel across Puducherry.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Quick Links</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "Home", path: "/" },
              { label: "Services", path: "/services" },
              { label: "Tariff", path: "/pricing" },
              { label: "About Us", path: "/about" },
              { label: "Blog", path: "/blog" },
              { label: "Contact", path: "/contact" },
            ].map((l) => (
              <Link key={l.path} to={l.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Popular Routes */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Popular Routes</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "Pondicherry to Chennai", path: "/routes/pondicherry-to-chennai" },
              { label: "Pondicherry to Bangalore", path: "/routes/pondicherry-to-bangalore" },
              { label: "Pondicherry to Tirupati", path: "/routes/pondicherry-to-tirupati" },
              { label: "Pondicherry to Madurai", path: "/routes/pondicherry-to-madurai" },
            ].map((l) => (
              <Link key={l.path} to={l.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-foreground font-semibold mb-4">Contact Us</h3>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-2">
              <a href="tel:+919952493907" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                <Phone className="w-4 h-4 text-primary" /> +91 99524 93907
              </a>
              <a href="tel:+919500454165" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors ml-6">
                +91 95004 54165
              </a>
            </div>
            <a href="mailto:elitetravelspondy@gmail.com" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
              <Mail className="w-4 h-4 text-primary" /> elitetravelspondy@gmail.com
            </a>
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <MapPin className="w-4 h-4 text-primary mt-0.5" /> 35, 2 nd Cross, Sivagami Nagar, Reddiyarpalayam, Pondicherry, 605010.
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="w-4 h-4 text-primary" /> 24/7 Available
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="container-custom py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} pondicherry.taxi. All rights reserved.
        </p>
        <p className="text-xs text-muted-foreground">
          Best taxi service in Pondicherry | Cab booking Puducherry
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
